import { GroupLinkDto, UsersApi } from '../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseGetUserGroupLinks = (
  usersApi: UsersApi,
  options?: Omit<
    UseMutationOptions<AxiosResponse<GroupLinkDto[]>, ErrorResponse, string>,
    'mutationFn'
    >,
) => UseMutationResult<AxiosResponse<GroupLinkDto[]>, ErrorResponse, string>;

export const useGetUserGroupLinks: UseGetUserGroupLinks = (
  usersApi,
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    async (userId: string) => usersApi.getUserGroupLinks(tenantId, userId),
    options,
  );
};
